import { render, staticRenderFns } from "./PeriodicSafetyCheckBuilding.vue?vue&type=template&id=e6ace736&scoped=true&"
import script from "./PeriodicSafetyCheckBuilding.vue?vue&type=script&lang=js&"
export * from "./PeriodicSafetyCheckBuilding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6ace736",
  null
  
)

export default component.exports